import { useState } from "react";

// Interactive before/after slider. Works with mouse and touch via range input.
export default function BeforeAfterSlider({
    before,
    after,
    beforeLabel = "Before",
    afterLabel = "After",
}) {
    const [pos, setPos] = useState(50);

    return (
        <div
            className="relative aspect-[16/10] w-full select-none overflow-hidden rounded-[24px] shadow-brand"
            data-testid="before-after-slider"
        >
            {/* After (base) */}
            <img
                src={after}
                alt={afterLabel}
                className="absolute inset-0 h-full w-full object-cover"
                draggable="false"
            />
            <span className="absolute right-4 top-4 rounded-full bg-brand-blue/90 px-3 py-1 text-xs font-bold uppercase tracking-widest text-white">
                {afterLabel}
            </span>

            {/* Before (clipped) */}
            <div
                className="absolute inset-0 h-full overflow-hidden"
                style={{ width: `${pos}%` }}
            >
                <img
                    src={before}
                    alt={beforeLabel}
                    className="absolute inset-0 h-full w-full object-cover"
                    style={{ width: `${100 / (pos / 100)}%`, maxWidth: "none" }}
                    draggable="false"
                />
                <span className="absolute left-4 top-4 rounded-full bg-brand-red px-3 py-1 text-xs font-bold uppercase tracking-widest text-white">
                    {beforeLabel}
                </span>
            </div>

            {/* Divider handle */}
            <div
                className="pointer-events-none absolute top-0 h-full w-[3px] bg-brand-red"
                style={{ left: `${pos}%`, transform: "translateX(-50%)" }}
            >
                <span className="absolute left-1/2 top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-brand-red bg-white shadow-lg">
                    <span className="grid grid-cols-2 gap-[2px]">
                        <span className="h-[6px] w-[6px] rounded-[1px] bg-brand-red" />
                        <span className="h-[6px] w-[6px] rounded-[1px] bg-brand-red" />
                        <span className="h-[6px] w-[6px] rounded-[1px] bg-brand-red" />
                        <span className="h-[6px] w-[6px] rounded-[1px] bg-brand-red" />
                    </span>
                </span>
            </div>

            <input
                type="range"
                min="0"
                max="100"
                value={pos}
                onChange={(e) => setPos(Number(e.target.value))}
                aria-label="Drag to compare before and after"
                data-testid="before-after-range"
                className="ba-range absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
            />
        </div>
    );
}
